const styles = {
  container: {},
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 2rem",
  },
  title: {
    color: "#171B5E",
    fontWeight: 400,
    fontSize: 24,
  },
  close: {
    color: "rgba(97, 97, 97, 0.5)",
    fontSize: "1rem",
    fontWeight: 500,
    cursor: "pointer",
  },
  divider: {
    borderTop: "0.8px solid #D7D7E0",
  },
  body: {
    padding: "1rem 2rem",
  },
  footer: {
    padding: "1rem 2rem",
  },
  submitBtn: {
    borderRadius: 5,
    padding: "0.4rem 2rem",
  },
  switchLabel: {
    fontSize: 14,
    color: " #8F92A1",
    fontWeight: 500,
    marginBottom: 5,
  },
};

export default styles;
